import { motion } from "framer-motion";
import { Star } from "lucide-react";

const reviews = [
  {
    name: "Michael Anderson",
    company: "Anderson Construction LLC",
    rating: 5,
    text: "Kingdom Wealth Financial helped us secure equipment financing when traditional banks turned us down. Their process was smooth and professional. We got funded within a week!",
  },
  {
    name: "Sarah Chen",
    company: "Tech Innovations Inc.",
    rating: 5,
    text: "The SBA loan process seemed daunting, but their team guided us every step of the way. We successfully expanded our business with their support. Highly recommended!",
  },
  {
    name: "David Martinez",
    company: "Martinez Real Estate Group",
    rating: 5,
    text: "We've closed multiple commercial real estate deals with Kingdom Wealth Financial. Their expertise and quick turnaround times are unmatched in the industry.",
  },
  {
    name: "Jennifer Thompson",
    company: "Bella's Boutique",
    rating: 5,
    text: "As a small business owner, the MCA option was perfect for managing seasonal inventory. The flexibility in repayment made all the difference for our cash flow.",
  },
  {
    name: "Robert Kim",
    company: "Kim's Auto Repair",
    rating: 5,
    text: "Their credit repair service improved my score by 150 points! I was then able to qualify for a business line of credit. Life-changing experience!",
  },
  {
    name: "Amanda Foster",
    company: "Foster Digital Marketing",
    rating: 5,
    text: "The 0% interest business credit card helped us manage expenses during our startup phase. Kingdom Wealth Financial truly understands entrepreneur needs.",
  },
];

export default function ReviewsSection() {
  return (
    <section className="py-24 px-6 md:px-12 relative overflow-hidden" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="font-playfair text-4xl md:text-6xl font-bold mb-4">
            <span className="gold-gradient-text" data-testid="reviews-heading">
              Client Success Stories
            </span>
          </h2>
          <p className="font-manrope text-white/70 text-lg max-w-2xl mx-auto">
            Hear from businesses we've helped achieve their goals
          </p>
        </motion.div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="glass-card p-8 rounded-xl hover:scale-102 transition-all duration-500"
              data-testid={`review-card-${index}`}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 fill-gold text-gold"
                  />
                ))}
              </div>

              {/* Review Text */}
              <p className="font-manrope text-white/80 text-sm leading-relaxed mb-6">
                "{review.text}"
              </p>

              {/* Reviewer Info */}
              <div className="border-t border-white/10 pt-4">
                <p className="font-manrope font-semibold text-white">
                  {review.name}
                </p>
                <p className="font-manrope text-gold-200 text-sm">
                  {review.company}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}